export default __webpack_public_path__ + "9d743f7835ed7f45558762265620248d.png";